import { render, staticRenderFns } from "./testapi.vue?vue&type=template&id=8e1287ea&scoped=true&"
import script from "./testapi.vue?vue&type=script&lang=js&"
export * from "./testapi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1287ea",
  null
  
)

export default component.exports